import { Injectable, signal, effect } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Injectable({ providedIn: 'root' })
export class NotifyService {
  workorderSignal = signal(0);

  private originalTitleText = 'GoingBus';
  private newMessageTitleText = '【工单回复】';
  private titleInterval: any = null;

  // currentPageTitle: string | null = null;
  currentPageTitle = signal('GoingBus');

  constructor(private title: Title) {
    effect(
      () => {
        const flag = this.workorderSignal();
        const currentTitle = this.currentPageTitle() || this.originalTitleText;

        // signal 为 true，开启闪烁
        if (flag !== 0) {
          this.startTitleFlash();
        } else {
          this.stopTitleFlash(currentTitle);
        }
      },
      { allowSignalWrites: true }
    );
  }

  // 页面切换时更新标题
  setPageTitle(title: string) {
    // this.currentPageTitle = title;
    this.currentPageTitle.set(title);
    this.title.setTitle(title);
    this.originalTitleText = title; // 更新基础标题
  }

  // 收到新工单
  newWorkorder(number: any) {
    this.workorderSignal.set(number);
  }

  // 清除通知
  clearWorkorder() {
    this.workorderSignal.set(0);
  }

  // 开始闪烁
  private startTitleFlash() {
    if (this.titleInterval) return; // 已经在闪烁就不重复创建

    let toggle = false;
    this.titleInterval = setInterval(() => {
      const currentTitle = this.currentPageTitle();
      const displayTitle = toggle
        ? this.newMessageTitleText + currentTitle
        : currentTitle;
      document.title = displayTitle;
      toggle = !toggle;
    }, 1000);
  }

  // 停止闪烁
  private stopTitleFlash(title: string) {
    if (this.titleInterval) {
      clearInterval(this.titleInterval);
      this.titleInterval = null;
    }
    this.title.setTitle(title); // 恢复原始标题
  }
}
